const logoStyle: { height: number; maxWidth: number; objectFit: 'contain' } = {
  height: 45,
  maxWidth: 200,
  objectFit: 'contain',
};

export function Logo({ logoUrl }: { logoUrl: string }) {
  return <img style={logoStyle} src={logoUrl} alt={'Home'} />;
}
